<template>
    <v-container fluid fill-height>
        <v-card color="transparent" outlined width="100%" class="fill-height pt-5 pb-5 mt-5 mb-5">
            <v-toolbar color="transparent" flat height="50">
                <v-toolbar-title>
                    <v-chip label color="amber">All ORDERS</v-chip>                    
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <a v-for="(menu, i) in menuProduct" :key="i" :href="`/orders/${menu.id}`" class="ancSetting">
                        <v-btn color='grey lighten-2' :class="`text-uppercase orderButton ml-5 elevation-0`" x-small>
                            {{menu.name}} 
                        </v-btn>
                    </a>
                </v-toolbar-items>
            </v-toolbar>         
        </v-card>
        <v-card class=mt-5 style="width:100%" outlined>
            <v-card-text>
                <v-data-table :headers="Header" :items="tabledata">
                    <template v-slot:item.status="{ item }">
                        <v-chip label small :color="item.status == 'approved' ? 'green': 'orange'" dark>{{item.status}}</v-chip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import { SERVER_API } from '../API';
import {bus} from '../main'
export default {
    mounted(){
        this.fetchProduct();
        this.fetchOrders();
    },
    created(){
        bus.$on('notify',() =>{
            this.fetchProduct();
            this.fetchOrders();
        })
    },
    
    data(){
        return{
            notificationBar:'',
            notificationColor:'black',
            notificationText:'',
            tabledata:[],
            menuProduct:[],
            //Header
            Header:[
                {text:'Order Id', value:"id"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Oil Content', value:"oilContent"},
                {text:'Offer Qty', value:"oQty"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Order date', value:"createdAt"},
                {text:'Final Qty', value:"fQty"},
                {text:'Final Rate', value:"fRate"},
                {text:'Final date', value:"updatedAt"},
                {text:'Status', value:"status"},
            ],
        }
    },
    methods:{
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.orderdilog=false;
                this.fetchOrders();
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;            
            }

        },
        async fetchOrders(){
            const response = await this.$http.get(SERVER_API+'/order/records');
            this.tabledata = response.data.data;
        },
        async fetchProduct(){
            try{
                const response = await this.$http.get(SERVER_API+'/product/byuser');
                this.menuProduct = response.data.data;
            }catch(error){
                alert(error);
            }
        }
    }

}
</script>

<style>
.tablefontsize .v-data-table__wrapper table tbody tr td{
    font-size: 10px !important;
}
.tablefontsize .v-data-table__wrapper table thead tr th{
    font-size: 10px !important;
    font-weight: bold;
    color:#000;
}
.orderButton{
    height:30px !important;
}
.ancSetting{
    text-decoration: none;
}
</style>